<div class="d-flex flex-column" *ngIf="entityType === EntityType.CAMPAIGN && eventType === EventType.BUDGET_CHANGES">
    <app-inventory-status-badge [status]="context?.decision?.inventory_status"></app-inventory-status-badge>
    <div class="mt-2" [innerHTML]="generateContextHTML(context)"></div>
</div>

<div class="d-flex flex-column" *ngIf="entityType === EntityType.ITEM && eventType === EventType.PRICING_CHANGES_BY_RECOMMENDATION">
    <app-item-pricing-inventory-health-chip [status]="context?.decision?.state"></app-item-pricing-inventory-health-chip>

    <!-- Price decision row -->
    <div class="price-decision mt-2" *ngIf="context?.decision?.custom_price">
        <!-- User override: show suggested → override -->
        <div class="price-decision__item">
            <span class="price-decision__label">Suggested</span>
            <span class="price-decision__value price-decision__value--muted">{{ formatCurrency(context?.decision?.suggested_price) }}</span>
        </div>
        <span class="price-decision__arrow">→</span>
        <div class="price-decision__item">
            <span class="price-decision__label">
                Override
                <span class="price-source-badge">User</span>
            </span>
            <span class="price-decision__value price-decision__value--override">{{ formatCurrency(context?.decision?.custom_price) }}</span>
        </div>
    </div>

    <div class="mt-2" [innerHTML]="generateContextHTML(context)"></div>
</div>